import { PropsWithChildren, useMemo, useState } from 'react'
import HinweisContext from '@/hooks/HinweisContext'
import { Dialog, DialogContent, DialogFooter } from '@/components/common/dialog'
import { Button } from '@repo/ui'
import { DoneIcon32 } from '@repo/ui/icons'

export default function HinweisProvider({
  children
}: Readonly<PropsWithChildren>) {
  const [title, setTitle] = useState<string>('')
  const [text, setText] = useState<string>('')
  const [instruction, setInstruction] = useState('')
  const [state, setState] = useState<boolean>(false)

  const setHinweis = (
    newTitle: string,
    newText: string,
    newInstruction?: string
  ) => {
    setTitle(newTitle)
    setText(newText)
    setState(true)
    if (newInstruction) {
      setInstruction(newInstruction)
    } else {
      setInstruction('')
    }
  }

  const value = useMemo(
    () => ({
      setHinweis
    }),
    []
  )

  return (
    <HinweisContext.Provider value={value}>
      <Dialog
        state={state}
        onClose={() => setState(false)}
        title={title}
        data-testid="hinweis-dialog"
      >
        <DialogContent
          className="my-2 flex flex-col gap-1"
          data-testid="hinweis-dialog-content"
        >
          <p data-testid="hinweis-dialog-content-text">{text}</p>
          {instruction !== '' && (
            <p
              className="font-bold"
              data-testid="hinweis-dialog-content-instruction"
            >
              {instruction}
            </p>
          )}
        </DialogContent>
        <DialogFooter data-testid="hinweis-dialog-footer">
          <div className="flex flex-col gap-1">
            <Button
              type="submit"
              variant="brand-primary"
              onClick={() => setState(false)}
              data-testid="hinweis-dialog-apply-button"
            >
              <DoneIcon32
                className="shrink-0"
                data-testid="hinweis-dialog-apply-button-icon"
              />
              <span
                className="pl-0.5"
                data-testid="hinweis-dialog-apply-button-text"
              >
                Schließen
              </span>
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
      {children}
    </HinweisContext.Provider>
  )
}
